import gql from 'graphql-tag'

export default gql`
  query administratorsCountQuery($role: Role!) {
    administratorsCount(role: $role)
  }
`
